<template>
  <div class="account-tab-item">
    <template v-if="isMob">
      <div v-if="!pending"
           class="account-tab-item__head-mob">
        <div class="account-tab-item__filter-btn-wrap">
          <button type="button"
                  class="account-tab-item__filter-btn"
                  @click.prevent="onOpenFilterMob">
            <BaseSvg name="ico-filter" class="_filter" width="1.3rem" height="1.3rem"/>
            <span>{{ $tAccount('Set filters') }}</span>
            <BaseSvg name="ico-arrow-light" class="_arrow" width=".4rem" height=".6rem"/>
          </button>
        </div>
      </div>
      <div v-if="pending"
           style="position: relative; padding: 3rem 2rem"
           class="account-tab-item__group">
        <BasePreloader/>
      </div>
      <div v-else-if="!items || !items.length"
           style="padding: 3rem 2rem; text-align: center"
           class="account-tab-item__group  text">
        <p>{{ $tAccount('You dont have income') }}</p>
      </div>
      <div v-else
           class="account-tab-item__group">
        <AccountTabItemWithdrawRowMobile v-for="item in items"
                                         :key="item.id"
                                         :item="item"/>
      </div>
    </template>

    <table class="account-tab-item__table" v-else>
      <AccountTabItemWithdrawHeaderDesktop v-if="filters"
                                           :filters="filters"
                                           :isChecked="isChecked"
                                           :onToggleFilter="onToggleFilter"
                                           :onClear="onClear"
                                           :filterSelectedProperties="filterSelectedProperties"/>
      <tbody>
      <tr v-if="pending">
        <td colspan="6" style="position: relative; padding: 4rem 0">
          <BasePreloader/>
        </td>
      </tr>
      <tr v-else-if="!items || !items.length">
        <td colspan="6"
            class="text"
            style="position: relative; padding: 3rem 2rem; text-align: center">
          <p>{{ $tAccount('You dont have withdraws') }}</p>
        </td>
      </tr>
      <template v-else>
        <AccountTabItemWithdrawRowDesktop v-for="item in items"
                                          :key="item.id"
                                          :item="item"/>
      </template>
      </tbody>
    </table>


    <div class="account-tab-item__pagination-wrap">
      <Pagination class="account-tab-item__pagination"
                  :style="paginationStyle"
                  :quantity="pagesQuantity"/>
      <AccountBalanceInfo :label="$tAccount('Available for withdrawal')"
                          :value="balance"
                          withdraw
                          class="account-tab-item__pagination-btn"
      />
    </div>

    <transition name="fade">
      <AccountTabItemWithdrawHeaderMobile v-if="showFilterMob && filters"
                                          :filters="filters"
                                          :isChecked="isChecked"
                                          :onToggleFilter="onToggleFilter"
                                          :onClear="onClear"
                                          :filterSelectedProperties="filterSelectedProperties"
                                          @close="onCloseFilterMob"/>
    </transition>
  </div>
</template>

<script>
  import Pagination from '@/components/Pagination'
  import AccountTabItemWithdrawRowDesktop from './AccountTabItemWithdrawRowDesktop'
  import AccountTabItemWithdrawRowMobile from './AccountTabItemWithdrawRowMobile'
  import AccountBalanceInfo from './AccountBalanceInfo'
  import AccountTabItemWithdrawHeaderDesktop from './AccountTabItemWithdrawHeaderDesktop'
  import AccountTabItemWithdrawHeaderMobile from './AccountTabItemWithdrawHeaderMobile'
  import accountBalanceMixin, {getComputedProperties} from '@/mixins/accountBalanceMixin'

  const filtersKeys = [
    'methods'
  ]

  export default {
    name: 'AccountTabItemWithdraw',
    mixins: [accountBalanceMixin],
    components: {
      AccountBalanceInfo,
      AccountTabItemWithdrawRowDesktop,
      AccountTabItemWithdrawRowMobile,
      AccountTabItemWithdrawHeaderDesktop,
      AccountTabItemWithdrawHeaderMobile,
      Pagination
    },
    props: {
      isMob: {
        type: Boolean,
        default: false
      },
      balance: Number
    },
    data() {
      return {
        apiLink: '/api/cabinet/payments/withdraw',
        filtersKeys,
        pending: false,
        items: null,
        filters: null,
        pagesQuantity: 0,

        showFilterMob: false,
        timer: null,
      }
    },
    computed: {
      ...getComputedProperties(filtersKeys)
    },
    methods: {
      checkMob() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (!this.isMob) {
            this.onCloseFilterMob()
          }
        }, 200)
      }
    },
    mounted() {
      window.addEventListener('resize', this.checkMob)
    },
    beforeDestroy() {
      this.onCloseFilterMob()
      window.removeEventListener('resize', this.checkMob)
    }
  }

</script>

<style>

</style>
